import React, { useEffect, useRef } from 'react';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import { useAuth } from '../../context/AuthContext';
import { Permission } from '../../utils/enums/permission.enum';
import { Roles } from '../../utils/enums/roles.enum';

interface TawkMessengerRefType {
  setAttributes: (_details: { name: string; email: string; hash: string }) => void;
}

function TawkChat() {
  const tawkMessengerRef = useRef<TawkMessengerRefType | null>(null);
  const { user, isLogin } = useAuth();

  const onLoad = () => {
    if (tawkMessengerRef.current && user.email && user.tawkHush) {
      tawkMessengerRef.current.setAttributes({
        name: `${user.firstName} ${user.familyName}`,
        email: user.email,
        hash: user.tawkHush,
      });
    }
  };

  useEffect(() => {
    if (!isLogin && user.tawkHush) {
      if (tawkMessengerRef.current) {
        tawkMessengerRef.current = null;
      }
    }
  }, [isLogin, user.tawkHush]);

  return (
    <div className="App">
      {isLogin &&
        user.tawkHush &&
        ((user.permissions && user.permissions.includes(Permission.PROVIDE_USAGE_FEEDBACK)) ||
          user.role === Roles.SAAS_ADMIN) && (
          <TawkMessengerReact
            propertyId={process.env.REACT_APP_TWAK_PROPERTY_ID as string}
            widgetId={process.env.REACT_APP_TWAK_WIDGET_ID as string}
            onLoad={onLoad}
            ref={tawkMessengerRef}
          />
        )}
    </div>
  );
}

export default TawkChat;
